import { useSearchParams } from 'react-router-dom';
import { queryKeyBuildings } from './useBuildingIds';

export const queryKeyClient = 'client';
export const queryKeyRecordId = 'recordId';

type SetClientId = (clientId: string) => void;

export function useClientId(): [string, SetClientId] {
  const [searchParams, setSearchParams] = useSearchParams();

  const clientId = searchParams.get(queryKeyClient) || '';

  const setClientId = (newClientId: string) => {
    searchParams.set(queryKeyRecordId, newClientId);
    searchParams.set(queryKeyClient, newClientId);
    searchParams.delete(queryKeyBuildings);

    setSearchParams(searchParams, { replace: false });
  };

  return [clientId, setClientId];
}
